var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rc-but-list',_vm._b({on:{"confirm":_vm.confirmButtonType}},'rc-but-list',_vm.$attrs.column.button || [],false))}
var staticRenderFns = []

export { render, staticRenderFns }